import { graphql } from "../gql";

export const createQueueMutationDoc = graphql(`
  mutation createQueue($input: CreateQueueInput!) {
    createQueue(input: $input) {
      queue {
        author {
          id
          firstName
          lastName
          userType
          email
        }
        createdAt
        description
        id
        indexedFilterTags
        name
      }
    }
  }
`);
